import { getObjectKeysAsObject } from "../../../helpers";
import type { CartContext } from "../context";
import { CartState } from "../types";

export const guards = {
  isCartLocked: (ctx: CartContext, _event: unknown) =>
    ctx[CartState.cartQuote].cartLocked === true,

  shouldDiscardCart: (ctx: CartContext, _event: unknown) => {
    const quoteAlreadyExists = !!ctx[CartState.cartQuote].priceQuoteCipherText;
    return quoteAlreadyExists;
  },
  hasCustomerEmail: (ctx: CartContext, _event: unknown) =>
    Boolean(ctx[CartState.cartQuote].customerEmail),
};

export const GuardTypes = getObjectKeysAsObject(guards);
